module.exports = __webpack_public_path__ + "img/17875_L.e08ca0de.png";